import React from "react"
import BaseComponent from "core/gd-components/base-component/base-component"

import Tooltip from "../components/tooltip"
import Portal from "../components/portal"

class TooltipEntity extends BaseComponent {
    constructor(props) {
        super(props);

        this.state = {
            showTooltipAt: null,
        };

        this._bind('openTooltip', 'closeTooltip', 'onEdit');
    }

    openTooltip(e) {
        const trigger = e.target;

        if (trigger instanceof Element) {
            this.setState({ showTooltipAt: trigger.getBoundingClientRect() });
        }
    }

    closeTooltip() {
        this.setState({ showTooltipAt: null });
    }

    onEdit() {
        const { entityKey, onEdit } = this.props;
        this.closeTooltip();
        onEdit(entityKey);
    }

    render() {
        const { entityKey, contentState, children, onEdit, onRemove, icon, label } = this.props;
        const { showTooltipAt } = this.state;
        const { url } = contentState.getEntity(entityKey).getData();

        const re = new RegExp("((?:https?:\\/\\/([^\\s]+(?:[^\\)| ]))))( )?(?:[\'\"]([\\s\\S]+?)[\'\"])?", 'gmi');
        const matchArr = re.exec(url);
        const link = matchArr ? matchArr[0] : url.includes('://') ? url : 'http://'+url;

        // Vic patch START
        if (!onEdit && !onRemove) {
            return (
                <a role="button" className="gd-rich-editor-tooltip-entity" onClick={(e)=>{
                    e.stopPropagation()
                    window.open(link, '_blank')
                }}>
                    <span className="gd-rich-editor-tooltip-entity__text">{children}</span>
                </a>
            );
        }
        // Vic patch End

        return (
            <a role="button" onMouseUp={this.openTooltip} className="gd-rich-editor-tooltip-entity">
                <span className="gd-rich-editor-tooltip-entity__text">{children}</span>
                {showTooltipAt && (
                    <Portal onClose={this.closeTooltip}
                            closeOnClick
                            closeOnType
                            closeOnResize >
                        <Tooltip target={showTooltipAt} direction="top">
                            <a rel        = "noopener noreferrer"
                               className  = "gd-rich-editor-tooltip-link"
                               onClick    = {(e)=>{
                                   e.stopPropagation()
                                   window.open(link)
                               }}>
                                {/*{label}*/}
                                Open link
                            </a>

                            {!!onEdit && <div className="gd-rich-editor-tooltip-button i5-pen" onClick={this.onEdit}> </div>}
                            {!!onRemove && <div className="gd-rich-editor-tooltip-button i5-delete-circle-solid" onClick={onRemove.bind(null, entityKey)}> </div>}
                        </Tooltip>
                    </Portal>
                )}
            </a>
        );
    }
}

export default TooltipEntity
